export default __webpack_public_path__ + "female-silhouette.png";